import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';

import * as confirmationActions from '../actions/confirmation.action';
import * as bookingActions from '../actions/booking.action';
import { mergeMap, switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { empty } from 'rxjs/observable/empty';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { BookingService } from '../../booking/services/booking.service';
import { Booking } from '../../booking/models/booking';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Injectable()
export class BookingEffect {
  constructor(
    private actions$: Actions,
    private db: AngularFirestore,
    private bookingService: BookingService,
    private firebaseAuth: AngularFireAuth,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router
  ) {}

  @Effect({ dispatch: false })
  addBooking$ = this.actions$.ofType(bookingActions.ADD_BOOKING).pipe(
    switchMap((action: bookingActions.AddBooking) => {
      this.spinnerService.show();
      const booking: Booking = action.payload;
      return this.bookingService.addBooking(booking).pipe(
        map(() => {
          this.router.navigate(['/bookings']);
          this.spinnerService.hide();
        })
      );
    }),
    // map(() => new bookingActions.ResetCurrentBooking()),
    catchError(error => of(new bookingActions.AddBookingFail(error)))
  );

  // @Effect()
  // editBooking$ = this.actions$.ofType(bookingActions.EDIT_BOOKING).pipe(
  //   switchMap((action: bookingActions.EditBooking) => {
  //     const updatedBooking = action.payload;
  //     return this.bookingService.updateBooking(updatedBooking);
  //   }),
  //   mergeMap(() => this.bookingService.getBookings()),
  //   map(bookings => new bookingActions.EditBookingSuccess(bookings)),
  //   tap(() => {
  //     this.router.navigate(['/bookings']);
  //     this.spinnerService.hide();
  //   }),
  //   catchError(error => of(new bookingActions.EditBookingFail(error)))
  // );

  @Effect()
  getBookings$ = this.actions$.ofType(bookingActions.GET_BOOKINGS).pipe(
    switchMap((action: bookingActions.GetBookings) => {
      this.spinnerService.show();
      return this.bookingService.getBookings();
    }),
    map(bookings => new bookingActions.GetBookingsSuccess(bookings)),
    tap(() => this.spinnerService.hide()),
    catchError(error => of(new bookingActions.AddBookingFail(error)))
  );

  // @Effect()
  // getCurrentBooking$ = this.actions$
  //   .ofType(bookingActions.GET_CURRENT_BOOKING)
  //   .pipe(
  //     switchMap((action: bookingActions.GetCurrentBooking) => {
  //       this.spinnerService.show();
  //       const bookingId = action.payload;
  //       return this.bookingService
  //         .getBooking(bookingId)
  //         .pipe(
  //           tap(console.log),
  //           map(
  //             booking => new bookingActions.GetCurrentBookingSuccess(booking)
  //           ),
  //           tap(() => this.router.navigate(['/bookings', bookingId, 'edit'])),
  //           tap(() => this.spinnerService.hide())
  //         );
  //     }),
  //     catchError(error => of(new bookingActions.GetCurrentBookingFail(error)))
  //   );

  @Effect({ dispatch: false })
  deleteBooking$ = this.actions$.ofType(bookingActions.DELETE_BOOKING).pipe(
    switchMap((action: bookingActions.DeleteBooking) => {
      // this.spinnerService.show();
      const bookingId = action.payload;
      const answer = window.confirm(
        'Do you really want to delete this booking?'
      );
      if (answer) {
        return this.bookingService.deleteBooking(bookingId);
      } else {
        // this.router.navigate(['/bookings']);
        return empty();
      }
    })
    // ,
    // map(bookings => new bookingActions.DeleteBookingSuccess(bookings)),
    // map(() => this.spinnerService.hide())
    // catchError(error => of(new bookingActions.AddBookingFail(error)))
  );
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/effects/booking.effect.ts